/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest,
  TelegramProductsUserControllerEnqueueDescriptionGenerationMutationResponse,
  TelegramProductsUserControllerEnqueueDescriptionGeneration401,
} from '../types/TelegramProductsUserControllerEnqueueDescriptionGeneration.ts';

function getTelegramProductsUserEnqueueDescriptionGenerationUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/products/description-generation/queue` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/description-generation/queue}
 */
export async function telegramProductsUserEnqueueDescriptionGeneration(
  data: TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest,
  config: Partial<RequestConfig<TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsUserControllerEnqueueDescriptionGenerationMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerEnqueueDescriptionGeneration401>,
    TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest
  >({
    method: 'POST',
    url: getTelegramProductsUserEnqueueDescriptionGenerationUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
